import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { FileText, CheckCircle2, XCircle, AlertTriangle, Shield, Scale } from 'lucide-react';

const GuidelinesPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <FileText className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4">Community Guidelines</h1>
            <p className="text-xl text-muted-foreground">Standards for a safe and trustworthy platform</p>
          </div>

          <div className="space-y-8">
            <section className="bg-card border border-border rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><CheckCircle2 className="w-6 h-6 text-green-500" /> What We Allow</h2>
              <ul className="space-y-3 text-muted-foreground">
                <li>• Personal fundraising for medical expenses, emergencies, education</li>
                <li>• Nonprofit and charity campaigns</li>
                <li>• Community and cause-based initiatives</li>
                <li>• Creative projects and business ventures (with clear terms)</li>
                <li>• Memorial and funeral expense campaigns</li>
              </ul>
            </section>

            <section className="bg-card border border-border rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><XCircle className="w-6 h-6 text-red-500" /> What We Don't Allow</h2>
              <ul className="space-y-3 text-muted-foreground">
                <li>• Fraudulent or misleading campaigns</li>
                <li>• Campaigns promoting hate, violence, or discrimination</li>
                <li>• Illegal activities or substances</li>
                <li>• Get-rich-quick schemes or pyramid schemes</li>
                <li>• Campaigns with false or misleading information</li>
                <li>• Spam or duplicate campaigns</li>
              </ul>
            </section>

            <section className="bg-card border border-border rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><AlertTriangle className="w-6 h-6 text-amber-500" /> Campaign Requirements</h2>
              <ul className="space-y-3 text-muted-foreground">
                <li>• Provide accurate and honest information</li>
                <li>• Use funds as described in your campaign</li>
                <li>• Post regular updates for donors</li>
                <li>• Respond to donor inquiries</li>
                <li>• Complete identity verification when required</li>
              </ul>
            </section>

            <section className="bg-card border border-border rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><Shield className="w-6 h-6 text-blue-500" /> Platform Enforcement</h2>
              <p className="text-muted-foreground mb-4">
                FundTheHope reserves the right to take action on campaigns that violate these guidelines, including but not limited to:
              </p>
              <ul className="space-y-3 text-muted-foreground">
                <li>• Removal or suspension of campaigns</li>
                <li>• Withholding or delaying fund disbursement</li>
                <li>• Permanent account suspension</li>
                <li>• Reporting to relevant authorities where required by law</li>
              </ul>
            </section>

            <section className="bg-card border border-border rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2"><Scale className="w-6 h-6 text-purple-500" /> Important Notice</h2>
              <p className="text-muted-foreground mb-4">
                FundTheHope acts as a technology platform connecting campaign organizers with donors. We do not endorse, guarantee, or verify the accuracy or legitimacy of any campaign. Donors contribute at their own risk. Donations are generally non-refundable, and refunds may only be considered at FundTheHope's sole discretion in cases of confirmed fraud.
              </p>
            </section>

            <section className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-8">
              <h2 className="text-xl font-semibold text-foreground mb-4">Report a Violation</h2>
              <p className="text-muted-foreground">
                If you believe a campaign violates our guidelines, please report it through our{' '}
                <a href="/report" className="text-emerald-500 hover:underline">Report a Campaign</a> page or contact us at{' '}
                <a href="mailto:trust@fundthehope.com" className="text-emerald-500 hover:underline">trust@fundthehope.com</a>.
                Our Trust & Safety team reviews all reports and takes appropriate action based on our policies.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GuidelinesPage;
